<template>
  <div>
    <el-upload
      class="upload-demo"
      action=""
      :multiple="false"
      show-file-list
      :limit="uploadLimit"
      :on-remove="onRemove"
      :on-success="onSuccess"
      :on-error="onError"
      :before-upload="beforeUpload"
      :before-remove="beforeRemove"
      :on-exceed="onExceed"
      :on-preview="handlePictureCardPreview"
      :file-list="fileList"
      :http-request="upload"
    >
      <el-button size="small" type="primary" v-loading="uploadLoading">
        点击上传
      </el-button>
    </el-upload>
    <el-dialog
      title="预览"
      :visible.sync="dialogVisible"
      :append-to-body="true"
    >
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "FileUpload",
  props: {
    uploadLimit: {
      type: Number
    },
    value: {
      type: String,
      default: {
        return: ""
      }
    }
  },
  data() {
    return {
      uploadLoading: false,
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: ""
    };
  },
  mounted() {},
  methods: {
    // 上传文件之前的钩子
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("上传文件大小不能超过10MB!");
        return;
      }
      this.uploadLoading = true;
    },
    // 文件列表移除文件时的钩子
    onRemove(file, fileList) {
      if (fileList.length > 0) {
        let list = fileList.map((item) => {
          return item.url;
        });
        this.$emit("change", list);
        this.$emit("input", list.toString());
      } else {
        this.$emit("change", []);
        this.$emit("input", "");
      }
    },
    // 文件上传成功时的钩子
    onSuccess(response, file, fileList) {
      this.uploadLoading = false;
      let list = fileList.map((item) => {
        // console.log(item)
        if (item.response) {
          for (const key in item.response.data) {
            return item.response.data[key];
          }
        } else {
          return item.url;
        }
      });
    },
    async upload(event) {
      // console.log(event,111)
      // return
      let res = await this.$Common.fileUploadNew(event);
      let name = this.getName(res.fileUrl);
      let fileList = this.fileList;
      // console.log(fileList)
      fileList.push({
        name: name,
        url: res.fileUrl
      });
      // console.log(fileList)
      this.uploadLoading = false;
      if (fileList.length > 0) {
        let list = fileList.map((item) => {
          return item.url;
        });
        this.$emit("change", list);
        this.$emit("input", list.toString());
      } else {
        this.$emit("input", "");
      }
    },
    // 文件上传失败时的钩子
    onError(file) {
      this.$message.error("图片上传失败！");
    },
    // 删除文件之前的钩子
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件超出个数限制时的钩子
    onExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.uploadLimit} 个文件，本次选择了 ${files.length} 个文件`
      );
    },
    // 	点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
      if (file.url) {
        this.dialogImageUrl = this.$store.state.config.fileUrl + file.url;
        //获取最后一个.的位置
        var index = this.dialogImageUrl.lastIndexOf(".");
        //获取后缀
        var ext = this.dialogImageUrl.substr(index + 1);
        if (this.isAssetTypeAnImage(ext)) {
          this.dialogVisible = true;
        } else {
        }
      }
    },
    getName(str) {
      // console.log(str)
      let arr = str.split("/");
      // console.log(arr);
      return arr[arr.length - 1];
    },
    isAssetTypeAnImage(ext) {
      return (
        [
          "png",
          "jpg",
          "jpeg",
          "bmp",
          "gif",
          "webp",
          "psd",
          "svg",
          "tiff"
        ].indexOf(ext.toLowerCase()) !== -1
      );
    }
  },
  computed: {},
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal) {
          let list = newVal.split(",");
          this.fileList = list.map((item) => {
            let data = item.split("/");
            let obj = {};
            obj.name = data.pop();
            obj.url = item;
            return obj;
          });
        } else {
          this.fileList = [];
        }
      },
      immediate: true
    }
  }
};
</script>
